import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom'

import { AccessibilityProvider } from './context/AccessibilityContext/AccessibilityContext'

import Header from './components/Header/Header'

import IndexPage from './pages/IndexPage/IndexPage'
import NewsPage from './pages/NewsPage/NewsPage'
import TeamPage from './pages/TeamPage/TeamPage'
import ProgramsPage from './pages/ProgramsPage/ProgramsPage'
import AboutPage from './pages/AboutPage/AboutPage'
import ContactsPage from './pages/ContactsPage/ContactsPage'
import UnitsPage from './pages/UnitsPage/UnitsPage'
import UnitPage from './pages/UnitPage/UnitPage'
import AccessibleWrapper from './components/AccessibleWrapper/AccessibleWrapper'

import Footer from './components/Footer/Footer'

import style from './app.module.scss'

import CookieConsent from './components/CookieConsent/CookieConsent'

const App = () => {
  return (
    <AccessibilityProvider>
    <Router>
    <div className={style.app}>
      <AccessibleWrapper
        background='#fff'
        color='#000'
      >
        <Header />
      </AccessibleWrapper>
      <div className={style.main}>
        <Routes>
          <Route path='/' element={<IndexPage />} />
          <Route path='/news/' element={<NewsPage />} />
          <Route path='/team/' element={<TeamPage />} />
          <Route path='/programs/' element={<ProgramsPage />} />
          <Route path='/about/*' element={<AboutPage />} />
          <Route path='/contacts/' element={<ContactsPage />} />

          <Route path='/units/' element={<UnitsPage />} />
          <Route path='/unit/:id' element={<UnitPage />} />

          <Route path='*' element={<IndexPage />} />
        </Routes>
      </div>
      <AccessibleWrapper
        background='#e22b36'
        color='#fff'
      >
        <Footer />
      </AccessibleWrapper>
      
      <CookieConsent />
      
    </div>
    </Router>
    </AccessibilityProvider>
  )
}

export default App